"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { billingIntentDestination, currentBillingIntent, rememberBillingIntent } from "@/app/lib/billingIntent";

export function BillingIntentCapture() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    rememberBillingIntent();
    const destination = billingIntentDestination(pathname, currentBillingIntent());
    if (destination) router.replace(destination);
  }, [pathname, router]);

  return null;
}
